import React, { useEffect, useState } from "react"
import EmployeeLayout from "../../../layout/EmployeeLayout"
import strings from '../../../translation'
import { useSelector, useDispatch } from "react-redux"
import Button from "../../../components/Button"
import { useHistory } from "react-router-dom"


const EmployeeDashboard = () => {
  const jobSites = useSelector(s => s.employeeHome.jobSites)
  const loading = useSelector(s => s.employeeHome.loading)
  const history = useHistory()
  const [selectedJobSite, setSelectedJobSite] = useState(null)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: "GET_JOB_SITES" })
  }
  , [])

  useEffect(() => {
    if(jobSites.length === 1){
      setSelectedJobSite(jobSites[0])
    }else{
      setSelectedJobSite(null)
    }
    
  }, [jobSites])
  
  return (
    <EmployeeLayout isActive={strings.HOME}>
      <div className="company-home-section">
          <div className="page-title">{strings.HOME}</div>
          <div>
             <h5>
                {strings.WHICH_JOBSITE_ARE_YOU_WORKING_AT_TODAY}
             </h5>
             {jobSites.length > 0 ? (
              <>
              <div className="jobsite" style={{border: "1px solid #ccc", padding: "20px", borderRadius: "15px",marginTop: "20px",marginBottom:30,width:'50%'}}>
                {jobSites.map((item, index) => (
                  <div key={index} className="jobsite-item" style={{display: "flex", justifyContent: "space-between", alignItems: "center",paddingTop: 5, paddingBottom: 5}}>
                    <div className="jobsite-name" style={{}}>{item.job_site_name}</div>
                    <div className="check-box">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedJobSite ? selectedJobSite.job_site_name === item.job_site_name : false}
                          onChange={() => {
                            if (selectedJobSite && selectedJobSite.job_site_name === item.job_site_name) {
                              setSelectedJobSite(null)
                            }else{
                              setSelectedJobSite(item)
                            }
                            
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                ))}
              </div>
              {selectedJobSite !=null && <Button
                className="board-btn sign-in-btn"
                showSpinner={loading}
                title={strings.NEXT}
                onClick={ () => {
                  history.push({
                    pathname: "/employee/training-video",
                    state: { jobSite: selectedJobSite }
                  })
                } }
              /> }
              </>
            ) : (
              <div className="no-jobsite" style={{border: "1px solid #ccc", padding: "20px", borderRadius: "15px",marginTop: "20px"}}>
                {loading ? (
                  <div className="loading">{strings.LOADING}</div>
                ) : (
                  <div className="no-jobsite-message">
                    {strings.JOBSITE_NOT_FOUND}
                  </div>
                )}
              </div>
            )}
          </div>
      </div>
    </EmployeeLayout>
  )
}


export default EmployeeDashboard
